// extracted by mini-css-extract-plugin
export var emptyState = "_52-d";
export var statCard = "_52-c";
export var table = "_52-0";
export var tableCell = "_52-4";
export var tableCellClickable = "_52-5 _52-4";
export var tableCellDefault = "_52-6 _52-4";
export var tableCellEmpty = "_52-8";
export var tableCellWithValue = "_52-7";
export var tableContainer = "_52-e";
export var tableHeaderWeight = "_52-1";
export var tableHeaderZone = "_52-2";
export var tableRowHeader = "_52-3";
export var viewModeButton = "_52-9";
export var viewModeButtonActive = "_52-a _52-9";
export var viewModeButtonInactive = "_52-b _52-9";